// import React from "react";
// import "./physiotherapy.css";
// import InquiryForm from "../InquiryForm";
// const PhysiotherapyGermany = () => {
//   return (
//     <div className="physio-container">
//       <h1 className="physio-title">Physiotherapy Career in Germany</h1>

//       <div className="physio-box">
//         <h2>Overview</h2>
//         <p>
//           In Germany, physiotherapists are highly respected and contribute to
//           patient recovery in hospitals, clinics, and rehabilitation centers.
//           The profession is well regulated and offers strong career stability.
//         </p>
//       </div>

//       <div className="physio-box">
//         <h2>Eligibility & Requirements</h2>
//         <ul>
//           <li>Completion of a recognized physiotherapy program (Bachelor’s).</li>
//           <li>Knowledge of German language (B2/C1 level recommended).</li>
//           <li>Licensing from German health authorities.</li>
//         </ul>
//       </div>

//       <div className="physio-box">
//         <h2>Job Prospects</h2>
//         <p>
//           Germany faces a shortage of healthcare professionals, creating strong demand.
//           Average salaries range from €35,000 to €55,000 annually with growth opportunities.
//         </p>
//       </div>

//       {/* Inquiry Form */}
//         <InquiryForm title="Inquire About Germany  Programs" />
//     </div>
//   );
// };

// export default PhysiotherapyGermany;

import React from "react";
import "./physiotherapy.css";
import InquiryForm from "../InquiryForm";

const PhysiotherapyGermany = () => {
  return (
    <div className="physio-container">

      {/* Hero */}
      <section className="physio-hero">
        <div className="physio-hero-content">
          <span className="physio-country-badge">🇩🇪 Germany</span>
          <h1>Physiotherapy Career in Germany</h1>
          <p>Easy entry · Strong demand · Permanent Residency opportunities</p>
        </div>
      </section>

      {/* Overview */}
      <section className="physio-section">
        <div className="physio-box full-width">
          <div className="box-icon">🌍</div>
          <h2>Overview</h2>
          <p>
            Germany is becoming a top choice for physiotherapists from India because of easy
            entry, strong demand, and Permanent Residency opportunities. To work as a
            physiotherapist in Germany, foreign-trained professionals need to have their
            qualifications recognized and pass a state examination <strong>(Staatsprüfung)</strong>.
            This process involves demonstrating sufficient German language proficiency
            (at least B2 level) and undergoing an evaluation of their qualifications,
            potentially including a practical language test.
          </p>
        </div>
      </section>

      {/* State Examination */}
      <section className="physio-section">
        <div className="physio-box">
          <div className="box-icon">📝</div>
          <h2>State Examination (Staatsprüfung)</h2>
          <ul className="physio-list">
            <li>
              <strong>Purpose:</strong> Mandatory step to obtain the license to practice
              physiotherapy in Germany.
            </li>
            <li>
              <strong>Eligibility:</strong> Candidates must hold a Bachelor's Degree in
              Physiotherapy at the time of exam.
            </li>
            <li>
              <strong>Format:</strong> Includes both written and practical/oral components
              where candidates demonstrate their knowledge and skills.
            </li>
          </ul>
        </div>

        {/* Language */}
        <div className="physio-box">
          <div className="box-icon">🗣️</div>
          <h2>German Language Requirement</h2>
          <p className="highlight-note">Very Important:</p>
          <ul className="physio-list">
            <li><strong>Minimum:</strong> B2 level German</li>
            <li><strong>Some states require:</strong> C1 medical German</li>
          </ul>
        </div>
      </section>

      {/* Salary */}
      <section className="physio-section">
        <div className="physio-box salary-card">
          <div className="box-icon">💰</div>
          <h2>Salary in Germany</h2>
          <div className="salary-grid">
            <div className="salary-item">
              <span className="salary-label">Starting Salary</span>
              <span className="salary-value">€2,200 – €3,000<small>/month</small></span>
            </div>
            <div className="salary-item">
              <span className="salary-label">Experienced</span>
              <span className="salary-value">€3,500 – €4,500<small>/month</small></span>
            </div>
            <div className="salary-item">
              <span className="salary-label">Clinic Owners</span>
              <span className="salary-value">Even Higher</span>
            </div>
          </div>
          <p className="salary-inr">
            📌 In INR: approximately <strong>₹2 lakh – ₹4 lakh/month</strong>
            &nbsp;| With experience: <strong>₹4 lakh+/month</strong>
          </p>
        </div>
      </section>

      <InquiryForm title="Inquire About Germany Programs" />
          <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>
    </div>
  );
};

export default PhysiotherapyGermany;